import { Badge, IconButton, Tooltip } from "@mui/material"
import { useDispatch, useSelector } from "react-redux";
import { resetSavedAlbums } from "../../../actions/albumListActions";
import { Refresh } from "@mui/icons-material";
import { anyDisablingProcess } from "../../../reducers/disablingProcesses";
import { useSavedAlbumsChanges } from "../../../hooks/savedAlbums/useSavedAlbumsChanges";

const RefreshAlbumsButton = () => {
    const disabled = useSelector(anyDisablingProcess);
    const { addedAlbums, removedAlbums } = useSavedAlbumsChanges();
    const dispatch = useDispatch();

    const WarningTooltipContent = () => {
        return (
            <div className="d-flex flex-column gap-0_5">
                <span>Refresh saved albums</span>
                {
                    addedAlbums && <span>Some new albums have been added externally</span>
                }
                {
                    removedAlbums && <span>Some loaded albums have been removed externally</span>
                }
            </div>
        )
    }

    const onClick = () => {
        dispatch(resetSavedAlbums())
    };

    return (
        <div className="relative-position">
            <Tooltip title={<WarningTooltipContent />}>
                <span>
                    <IconButton disabled={disabled} color={addedAlbums || removedAlbums ? "warning" : "primary"} onClick={onClick}>
                        <div className="d-flex flex-row ai-center jc-center">
                            <Badge color="error" variant="dot" invisible={!addedAlbums && !removedAlbums}>
                                <Refresh />
                            </Badge>
                        </div>
                    </IconButton>
                </span>
            </Tooltip>
        </div>
    )
}

export default RefreshAlbumsButton;